<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-tab :tab-items="tabItems" @itemClick="itemClickHandler"></c-tab>
      <c-content>
        <div class="tickets" v-if="ticketList.length > 0">
          <div class="ticket" v-for="(item,index) in ticketList"
               :key="index"
               :class="[ticketPrimary ? 'primary':'']"
               >
            <div class="part-1">
              <p class="price">
                <sup>￥</sup>
                {{ item.price }}
              </p>
            </div>
            <div class="line"></div>
            <div class="part-2">
              <div class="info">
                <div class="title">{{ item.title }}</div>
                <ul class="desc">
                  <li v-for="desc in item.descs">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="empty" v-else>
          暂无礼金券
        </div>
      </c-content>
    </c-page>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  import Tickets from '../../../model/tickets'
  export default{
    data () {
      return {
        ticketList: [],
        ticketPrimary: true,
        tabItems: [{
          name: '未使用',
          select: true,
          ticketsList: []
        }, {
          name: '已使用',
          select: false,
          ticketsList: []
        }, {
          name: '已失效',
          select: false,
          ticketsList: []
        }],
        tickets: new Tickets()
      }
    },
    components: {},
    created () {
      this.tickets.usedTicketList().then(res => {
        for (let index of [0, 1, 2]) {
          this.tabItems[index]['ticketsList'] = res[index]
          this.tabItems[index]['name'] += `(${res[index].length})`
        }
        this.ticketList = this.tabItems[0]['ticketsList']
        this.ticketPrimary = true
      }).catch(e => {})
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      itemClickHandler (itemObj) {
        this.ticketPrimary = this.tabItems[0] === itemObj
        this.ticketList = itemObj.ticketsList
        for (let item of this.tabItems) {
          item.select = item === itemObj
        }
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?fe62bbd8